module.exports = __webpack_public_path__ + "static/media/(V)_MG_5886_-_Cia_Termal_Beachewear_-_Moda_Feminina.1b4e0ba0.jpg";